"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _onUserDataFetchSuccess = require("./onUserDataFetchSuccess");
Object.keys(_onUserDataFetchSuccess).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _onUserDataFetchSuccess[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _onUserDataFetchSuccess[key];
    }
  });
});